import http from "./http.js";

export const industryApi = {
  /**
   * 产业嘉宾名录
   * page --页码
   * mainId -- 届次
   * guestType -- 身份类型（10创投嘉宾、13市场嘉宾）
   * guestAuthKey -- 模糊查询
   */
  getAuthList: (data) => {
    return http.postRequestToken("/uc/reg/guestAuthPageList", data);
  },
  /**
   * 支付记录
   */
  getPayList: (mainId) => {
    return http.postRequestToken("/uc/guestPay/payList", {
      mainId
    })
  },
  // 开票
  invoice: (data) => {
    return http.postRequestToken("/uc/guestPay/invoice", data)
  },
  /**
   * 我的电子码
   * accountId
   * mainId
   */
  getCode: (data) => {
    return http.postRequestToken("/uc/guestActivitySign/getGuestCodeData", data)
  },
}

export const activityApi = {
  /**
   * 我的活动预约列表
   * mainId
   * accountId
   */
  getSignList: (data) => {
    return http.postRequestToken("/uc/guestActivitySign/getGuestActivitySignList", data);
  },
  /**
   * 活动列表
   * page (pageNum、pageSize、total)
   * mainId
   * accountId
   */
  getActivityList: (data) => {
    return http.postRequestToken("/uc/guestActivitySign/queryActivityList", data)
  },
  /**
   * 活动详情
   * activityId
   * accountId
   * mainId
   */
  getActivityDetail: (data) => {
    return http.postRequestToken("/uc/guestActivitySign/getGuestActivityDetail", data)
  },
  /**
   * 活动预约
   * guestActivityId
   * accountId
   * mainId
   */
  sign: (data) => {
    return http.postRequestToken("/uc/guestActivitySign/saveGuestActivity", data)
  },
  /**
   * 取消预约
   * activitySignId
   */
  cancel: (activitySignId) => {
    return http.postRequestToken("/uc/guestActivitySign/cancelGuestActivity", { activitySignId })
  },
}